<template>
	<div class="sidebar">
		<div class="sidebar__title">Выбор игры</div>
		<div class="sidebar__items">
			<router-link class="sidebar__item" :to="{name: 'dice'}" :class="[page === 'dice' ? 'active' : '']">
				<span class="sidebar__item-logo">
					<svg class="sidebar__item-icon"><use href="#svg-icon-dice"></use></svg>
				</span>
				<span class="sidebar__item-text">Dice</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'mines'}" :class="[page === 'mines' ? 'active' : '']">
				<span class="sidebar__item-logo">
					<svg class="sidebar__item-icon"><use href="#svg-icon-mines"></use></svg>
				</span>
				<span class="sidebar__item-text">Mines</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'slots'}" :class="[page === 'slots' || page === 'slotsGame' ? 'active' : '']">
				<span class="sidebar__item-logo">
					<svg class="sidebar__item-icon"><use href="#svg-icon-slots"></use></svg>
				</span>
				<span class="sidebar__item-text">Slots</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'live'}" :class="[page === 'live' ? 'active' : '']">
				<span class="sidebar__item-logo">
					<svg class="sidebar__item-icon"><use href="#svg-icon-live"></use></svg>
				</span>
				<span class="sidebar__item-text">Live</span>
			</router-link>
			<router-link class="sidebar__item" :to="{name: 'coinflip'}" :class="[page === 'coinflip' ? 'active' : '']">
				<span class="sidebar__item-logo">
					<svg class="sidebar__item-icon"><use href="#svg-icon-coinflip"></use></svg>
				</span>
				<span class="sidebar__item-text">Coin</span>
			</router-link>
			<router-link class="sidebar__item disabled" :to="{name: 'coinflip'}" :disabled="true" :class="[page === 'wheel' ? 'active' : '']">
				<span class="sidebar__item-logo">
					<svg class="sidebar__item-icon"><use href="#svg-icon-wheel"></use></svg>
				</span>
				<span class="sidebar__item-text">Wheel</span>
			</router-link>
		</div>
	</div>
</template>

<script>
    export default {

		computed: {
			page() {
				return this.$route.name
			}
		}
    }
</script>